export default __webpack_public_path__ + "static/media/immosaar24.d6cacae9.png";